import { Expose } from 'class-transformer';

export class S3PreSignedModel {
  @Expose()
  s3ObjectKey: string;

  @Expose()
  preSignedUrl: string;
}
